/**
 * Vite dev entry. In production the shell .wgt loads bundle-entry.tsx
 * via a downloaded blob URL; here we just invoke its `start` function
 * directly so dev and prod share exactly the same boot path.
 *
 * In Tizen/prod the shell hands us the boardId pulled from the prior
 * pairing flow; in dev we let PlayerScreen do the pairing itself by
 * passing boardId=undefined.
 */

import { start } from './bundle-entry';

const root = document.getElementById('root');
if (!root) throw new Error('No #root element in DOM');

void start({
  mountTarget: root,
  bundleVersion: 'dev',
  shellVersion: 'dev',
});
